import { gql } from 'graphql-tag';

export const staffCategoriesQuery = gql`
    query staffCategories {
      scenkonstStaffCategories {
        id
        name
        listType
      }
    }
  `;
